import { type Permission } from '@aid/shared';
import { usePermissions } from '../providers';
import { hasCobradorPaymentScope } from './payment-scope';

export function useHasPermission(permission: Permission): boolean {
  const { permissions } = usePermissions();
  return permissions.includes(permission);
}

export function useHasAnyPermission(...perms: Permission[]): boolean {
  const { permissions } = usePermissions();
  return perms.some((p) => permissions.includes(p));
}

export function useHasAllPermissions(...perms: Permission[]): boolean {
  const { permissions } = usePermissions();
  return perms.every((p) => permissions.includes(p));
}

export function useHasCobradorPaymentScope(): boolean {
  const { permissions } = usePermissions();
  return hasCobradorPaymentScope(permissions);
}
